module.exports = __webpack_public_path__ + "static/media/13.37059724.jpg";